import { useState, useEffect } from 'react';

// MUI x-charts feeds the series color into d3-color (brighter()/hover), which
// can't parse `var(...)`, so CSS-var colors must be resolved to a hex string at
// runtime before they reach a chart. Shared by every chart in this folder.
export function useResolvedCssColor(varName) {
    const [color, setColor] = useState(() => {
        if (typeof window === 'undefined') return undefined;
        return getComputedStyle(document.documentElement)
            .getPropertyValue(varName).trim() || undefined;
    });
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const value = getComputedStyle(document.documentElement)
            .getPropertyValue(varName)
            .trim();
        if (value) setColor(value);
    }, [varName]);
    return color;
}

export function moneySymbol(currency = 'BRL') {
    return String(currency).toUpperCase() === 'USD' ? 'US$' : 'R$';
}

export function formatMoneyCompact(value, currency = 'BRL') {
    const symbol = moneySymbol(currency);
    const abs = Math.abs(value);
    if (abs >= 1_000_000) return `${symbol}${(value / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
    if (abs >= 1_000) return `${symbol}${(value / 1_000).toFixed(1).replace(/\.0$/, '')}k`;
    return `${symbol}${value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}

export function formatMoneyFull(value, currency = 'BRL') {
    return `${moneySymbol(currency)} ${value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatNumberCompact(value) {
    const abs = Math.abs(value);
    if (abs >= 1_000_000) return `${(value / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
    if (abs >= 1_000) return `${(value / 1_000).toFixed(1).replace(/\.0$/, '')}k`;
    return String(value);
}

// "12 vendas" / "1 venda" — a count paired with its (pt-BR) unit noun.
export function formatCountFull(value, singular = 'item', plural = 'itens') {
    const n = Number(value) || 0;
    const noun = n === 1 ? singular : plural;
    return `${n.toLocaleString('pt-BR')} ${noun}`;
}
